module.exports = __webpack_public_path__ + "static/scindo_team_b&w-eefa739b4354f1abfa8fca68fe5554ae.jpg";